export var transformedColor = function transformedColor(color) {
  return color && (color.includes('.') ? color : "".concat(color, ".main"));
}; // export const cleanColorName = (color: string | TAGColorType) => {
//   if (!color) {
//     return 'secondary'
//   }
//   const defaultPalettes = ['error', 'primary', 'secondary', 'info', 'success', 'warning', 'accent01']
//   return defaultPalettes.includes(color) || defaultPalettes.includes(`${color.substring(0, color.indexOf('.'))}`)
//     ? color.includes('.')
//       ? (`${color.substring(0, color.indexOf('.'))}` as TAGColorType)
//       : (color as TAGColorType)
//     : ('secondary' as TAGColorType)
// }